var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavMainBarCategory',{attrs:{"current-item":_vm.onSaleCategory,"bold":true,"color":"text-EXPONDO-red"}})}
var staticRenderFns = []

export { render, staticRenderFns }